import type { Block, Inline } from '@contentful/rich-text-types';

import type { EmbedYoutube } from '../embed-youtube/embed-youtube.types';
import type { Table } from '../table/table.types';

export const toEmbedYoutubeProps = (
  node: Block | Inline,
): EmbedYoutube | undefined => {
  const id = node?.data?.target?.fields?.embedCode;

  if (id) {
    return { id };
  }

  return undefined;
};

export const toTableProps = (node: Block | Inline): Table | undefined => {
  const rows = node?.data?.target?.fields?.rows;

  if (rows) {
    return { rows };
  }

  return undefined;
};
